import { getQueryVariable } from "./_global";

$(document).ready(function () {
  var view = getQueryVariable('view');
  var loadOrderPage = !!view && view === 'orders';

  var selectors = {
    AccountHeading: '.account__heading',
    YourAccountBlock: '.account__account-details',
    OrderHistoryBlock: '.account__order-history',
    DropdownSelect: '.account .dropdown-select',
    DropdownSelectLabel: '.dropdown-select__label-text',
    ActiveNavItemSelector: '.dropdown-select__item--active',
    ContentBlockHeading: '.account__content-block-heading',
    ViewAllOrdersLink: "[data-link-id='viewAllOrders']",
  };

  function setNavigation(navItemId, dropdownLabelText) {
    $(selectors.ActiveNavItemSelector).removeClass('dropdown-select__item--active');
    $(selectors.DropdownSelect + ' ' + selectors.DropdownSelectLabel).text(dropdownLabelText);
    var navigationItem = $(selectors.DropdownSelect).find("[data-nav-item-id='" + navItemId + "']");
    navigationItem.addClass('dropdown-select__item--active');
  }

  function setOrdersActive() {
    setNavigation('orders', 'Orders');
    $(selectors.OrderHistoryBlock + ' ' + selectors.ContentBlockHeading).text('All Orders');
    $(selectors.AccountHeading).text('All Orders');
    $(selectors.YourAccountBlock).addClass('hide');
    $(selectors.ViewAllOrdersLink).addClass('hide');
  }

  if (loadOrderPage) {
    setOrdersActive();
  }

  function updateCustomerTags() {
    const tags = [];
    const customerTypes = document.getElementsByName('customer[Type]');
    const acceptsMarketing = document.getElementById('RegisterForm-sign-up');
    const customerTagsInput = document.getElementById('RegisterForm-customer-tags');
    customerTypes.forEach((item) => {
      if (item.checked) {
        tags.push(item.value);
      }
    });

    if (acceptsMarketing.checked == true) {
      tags.push('newsletter')
    }

    const customerTags = tags.filter(Boolean).toString().toLowerCase();
    customerTagsInput.value = customerTags
  }

  if ($('#RegisterForm')) {
    $(document).on('change', '#RegisterForm #RegisterForm-sign-up', function () {
      updateCustomerTags()
    });
    $(document).on('change', '#RegisterForm .radio__input', function () {
      updateCustomerTags()
    });
  }
});
